export default __webpack_public_path__ + "static/media/slide-cell-5.8b5c0985.svg";